const HTML_ENTITY_LOOKUP: Record<string, string> = {
  amp: '&',
  apos: "'",
  gt: '>',
  lt: '<',
  quot: '"',
};

function decodeCodePoint(codePoint: number, entity: string): string {
  if (!Number.isFinite(codePoint) || codePoint < 0 || codePoint > 0x10ffff) {
    return `&${entity};`;
  }

  return String.fromCodePoint(codePoint);
}

function decodeHtmlEntity(entity: string): string {
  if (entity.startsWith('#x') || entity.startsWith('#X')) {
    return decodeCodePoint(Number.parseInt(entity.slice(2), 16), entity);
  }

  if (entity.startsWith('#')) {
    return decodeCodePoint(Number.parseInt(entity.slice(1), 10), entity);
  }

  return HTML_ENTITY_LOOKUP[entity] ?? `&${entity};`;
}

export function decodeHtmlEntities(value: string): string {
  return value.replace(/&(#\d+|#x[\da-f]+|#X[\dA-F]+|amp|apos|gt|lt|quot);/g, (_, entity: string) =>
    decodeHtmlEntity(entity),
  );
}

export function normalizePayloadText(value: string): string {
  return decodeHtmlEntities(value).trim();
}
